export default "__VITE_ASSET__CaFVp7_E__"